
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'avatar-user': {
    width: 36,
    height: 36,
    viewBox: '0 0 36 36',
    data: '<path pid="0" d="M17.898 0C8.013 0 0 8.058 0 17.998c0 3.551 1.027 6.86 2.793 9.649l-2.755 8.31 8.264-2.77a17.736 17.736 0 0 0 9.596 2.808c9.885 0 17.897-8.057 17.897-17.997S27.783 0 17.898 0"/>'
  }
})
